import axios from '../utils/axios';

export default function postResumeBuilderCandidate(data) {
    return (
        axios.post('/resumeBuilder/subscription/admin/activateUser',  data )
        .then(res => {
            return res
        })
        .catch(err => {
            return err;
        })
    )
}
